'use client';

import { apClickIdSafeLocalStorage } from '@module/lib/storage/storageImplementations';
import { useEffect } from 'react';

function SaveMarketingSearchParams() {
  useEffect(() => {
    // 에이스플래닛 광고 스크립트
    // https://doublemedia.atlassian.net/browse/FDM-314?atlOrigin=eyJpIjoiZDVjNGZkNzZhNjJmNDA5ZGI1ZmYyMTIxODIxM2ZhZTYiLCJwIjoiaiJ9
    // 'click_id' search param을 가지고 접속한 유저에 대해 그 값을 저장해두어야 함
    const clickId = new URLSearchParams(window.location.search).get('click_id');
    if (clickId) {
      apClickIdSafeLocalStorage.set(clickId);
    }
  }, []);
  return null;
}

export default SaveMarketingSearchParams;
